import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SnackbarState {
  isOpen: boolean;
  message: string;
  icon?: React.ReactNode;
  buttonText?: string;
  type?: "success" | "error";
  autoCloseDuration?: number | null;
  key?: number;
}

const initialState: SnackbarState = {
  isOpen: false,
  message: "",
  icon: undefined,
  buttonText: "",
  type: "success",
  autoCloseDuration: 3000,
};

const confirmSnackbarSlice = createSlice({
  name: "confirmSnackbar",
  initialState,
  reducers: {
    showSnackbar: (
      state,
      action: PayloadAction<{
        message: string;
        icon?: React.ReactNode;
        buttonText?: string;
        type?: "success" | "error";
        autoCloseDuration?: number | null;
      }>
    ) => {
      state.isOpen = true;
      state.message = action.payload.message;
      state.icon = action.payload.icon;
      state.buttonText = action.payload.buttonText;
      state.type = action.payload.type || "success";
      state.autoCloseDuration =
        action.payload.autoCloseDuration === undefined
          ? 3000
          : action.payload.autoCloseDuration;
      state.key = Date.now();
    },
    hideSnackbar: (state) => {
      state.isOpen = false;
      state.message = "";
      state.icon = undefined;
      state.buttonText = "";
      state.type = "success";
      state.autoCloseDuration = 6000;
      state.key = undefined;
    },
  },
});

export const { showSnackbar, hideSnackbar } = confirmSnackbarSlice.actions;
export default confirmSnackbarSlice.reducer;
